/**
 * Copyright (C) 2019 User X, LLC http://whoisuserx.com <info@userx.co>
 *
 * This program is the intellectual property of User X, LLC. You may
 * not redistribute and/or modify it without written consent by controlling
 * entities of User X, LLC.
 *
 * You should have received a copy of our Web Developer Agreement which
 * outlines proper use and distribution of this program. If you did not
 * please email info@userx.co to request your copy.
 */
/**
 * File created by John M. Woodcock < john@userx.co >
 * on 8/16/2025
 * for userx-support
 */

import {useEffect, useState} from "react";
import supportAPI from "../../_apis/supportAPI";
import {search, sortObjects} from "../../_utilities/reactUtils";
import {fetchContact} from "../../_utilities/contactUtilities";

const AdminAgents = () => {
    const [agentList, setAgentList] = useState([]);
    const asArray = v => (Array.isArray(v) ? v : Array.isArray(v?.data) ? v.data : []);
    const byNum = (key) => (a, b) => Number(a?.[key] ?? 0) - Number(b?.[key] ?? 0);


    useEffect(() => {

        search('contact', [`t.group_id < 5`])
        .then(res => {
            const rows = asArray(res);
            setAgentList(rows.slice().sort(byNum('contact_id')));
        })
        .catch(err => {
            console.error('AdminAgents::load agents failed', err);
        });
    }, []);

    const handleDelete = async (agentId) => {
        const ok = window.confirm(
            "This will delete the company, company contacts, company metadata permanently. Continue?"
        );
        if (!ok) return;

        try {
            await supportAPI.delete(`/contact/${agentId}`);
            setAgentList(prev => prev.filter(a => a.contact_id !== agentId));
        } catch (e) {
            console.error("Delete failed", e);
            alert("Failed to delete agent");
        }
    };

    return (
        <div className="component-container d-flex flex-column h-100">
            <h3>Manage Agents</h3>
            <p>Basically it is a list of User X Agents.</p>

            <div>
                {agentList.map(a => (
                    <AgentRow key={a.contact_id} agent={a} onDelete={handleDelete}/>
                ))}
            </div>
        </div>
    );
};

function AgentRow({agent, onDelete}) {
    const [primary, setPrimary] = useState(null);
    const [loading, setLoading] = useState(true);

    const emailHref = agent?.email ? `mailto:${agent.email}` : undefined;
    const telHref = agent?.phone ? `tel:${agent.phone}` : undefined;

    const disabled = (href) => !href;

    return (
        <div className="alert border-opacity-10 border-dark py-2 mb-1 d-flex align-items-start">
            <h4 className="my-0 py-0 small flex-grow-1">
                {agent.first_name} {agent.last_name}
            </h4>

            <a className="d-block" href={`/agents/${agent.contact_id}/tickets`} title="Dashboard">
                <i role="button" className="bi bi-speedometer px-2"/>
            </a>

            <a className="d-block" href={`/agents/${agent.contact_id}/time`} title="Time">
                <i role="button" className="bi bi-clock px-2"/>
            </a>

            <a
                className={`d-block ${disabled(emailHref) ? "disabled opacity-50" : ""}`}
                href={emailHref || "#"}
                onClick={e => { if (disabled(emailHref)) e.preventDefault(); }}
                title={loading ? "Loading primary..." : (emailHref ? "Email Primary" : "No primary email")}
                target="_blank" rel="noreferrer"
            >
                <i role="button" className="bi bi-envelope-plus px-2"/>
            </a>

            <a
                className={`d-block ${disabled(telHref) ? "disabled opacity-50" : ""}`}
                href={telHref || "#"}
                onClick={e => { if (disabled(telHref)) e.preventDefault(); }}
                title={loading ? "Loading primary..." : (telHref ? "Call Primary" : "No primary phone")}
                target="_blank" rel="noreferrer"
            >
                <i role="button" className="bi bi-telephone-outbound px-2"/>
            </a>

            <a className="d-block" href={`/agents/${agent.contact_id}`} title="Delete" onClick={(e) => {
                e.preventDefault();
                onDelete(agent.contact_id);
            }}>
                <i role="button" className="bi bi-trash text-danger ms-3 px-1" />
                </a>
                </div>
                );
            }

export default AdminAgents;
